'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _auth = require('../../redux/modules/auth');

var _Checkbox = require('../Checkbox/Checkbox');

var _RememberMe = require('./RememberMe.scss');

var _RememberMe2 = _interopRequireDefault(_RememberMe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rememberMeCheckboxId = 'rememberMe';

var RememberMe = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, rememberMe: state.auth.rememberMe };
}, { editRememberMe: _auth.editRememberMe }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(RememberMe, _Component);

  function RememberMe() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RememberMe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RememberMe.__proto__ || (0, _getPrototypeOf2.default)(RememberMe)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.props.editRememberMe(true);
    }, _this.handleChange = function (isChecked) {
      _this.props.editRememberMe(isChecked);
    }, _this.hasRememberMe = function () {
      return !_this.props.auth.isMobile;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RememberMe, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          rememberMe = _props.rememberMe,
          theme = _props.theme;

      var hasRememberMe = this.hasRememberMe();
      return hasRememberMe ? _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: _RememberMe2.default.rememberMe },
          _react2.default.createElement(_components.Checkbox, { theme: theme, checkboxId: rememberMeCheckboxId, isChecked: rememberMe, onCheckboxChange: this.handleChange }),
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.RememberMe)
        )
      ) : null;
    }
  }]);
  return RememberMe;
}(_react.Component), _class2.defaultProps = {
  className: '',
  rememberMe: true,
  theme: _Checkbox.CheckboxTheme.LIGHT
}, _class2.propTypes = {
  auth: _react.PropTypes.object,
  className: _react.PropTypes.string,
  editRememberMe: _react.PropTypes.func.isRequired,
  rememberMe: _react.PropTypes.bool,
  theme: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = RememberMe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RememberMe/RememberMe.js
// module id = 1985
// module chunks = 0